import {Link} from 'react-router-dom'

const FirstPageFooter = () => {
    return (
        <footer className="firstpage-footer">
            <Link to="/privacy" className="footer-a">Privacy</Link>
            <Link to="/about" className="footer-a">About</Link>
            <a href="http://joepetryan.rf.gd" className="footer-a">JRQ</a>
        </footer>
    )
}
export default FirstPageFooter
